<template>
  <div>
    <div class="p-4 bg-gradient-to-br from-gray-900 to-black rounded-xl border border-gray-800 shadow-xl">
      <!-- Header با Glass Effect -->
      <div class="mb-6">
        <h3 class="text-xl font-bold inline-block">
          <span class="bg-clip-text text-transparent bg-gradient-to-r from-purple-400 via-pink-400 to-blue-400">
            گزارش فروش آنلاین
            <span v-if="filters.date"> {{ filters.date.split('-').reverse().join('-') }} </span>
          </span>
        </h3>

        <!-- فیلترها -->
        <div class="mt-4 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div class="flex flex-wrap gap-3">
            <input v-model="filters.id" @input="fetchOrders(1)" type="number"
                   placeholder="شماره سفارش"
                   class="px-4 py-2 bg-gray-800/70 text-gray-200 rounded-lg border border-gray-700 w-40 text-right backdrop-blur-sm">

            <date-field
                class="px-4 py-2 bg-gray-800/70 text-gray-200 rounded-lg border border-gray-700 w-40 text-right backdrop-blur-sm"
                placeholder="تاریخ"
                v-model="filters.date"
                @input="fetchOrders(1)">
            </date-field>

            <button
                @click="resetFilters"
                class="p-3 bg-gradient-to-r from-gray-700 to-gray-800 text-gray-300 rounded-full border border-gray-600 hover:bg-gray-700 transition"
                title="حذف فیلترها"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Popup تایید (بدون تغییر) -->
      <div v-if="showPopup" class="fixed inset-0 z-50 flex items-center justify-center">
        <div @click="showPopup = false" class="fixed inset-0 bg-black/70 backdrop-blur-sm"></div>
        <div class="relative bg-gray-800/90 p-6 rounded-xl border border-gray-700 max-w-xl w-full mx-4 backdrop-blur-lg">
          <h3 class="text-lg font-bold mb-6 text-gray-100">تایید ارسال سفارشات</h3>
          <p class="mb-3 text-gray-300">آیا از تغییر وضعیت {{ orders.length }} سفارش به «ارسال شده» اطمینان دارید؟</p>
          <p class="mb-3 text-purple-400 font-bold text-md">این عملیات قابل بازگشت نیست از پرینت فاکتور ها اطمینان داشته باشید</p>
          <p class="text-gray-300">آیا مطمئن هستید که می‌خواهید ادامه دهید؟</p>

          <div class="flex justify-end gap-3 mt-6">
            <button @click="showPopup = false" class="px-4 py-2 bg-gray-700 text-gray-300 rounded-lg hover:bg-gray-600 transition border border-gray-600">
              انصراف
            </button>
            <button @click="confirmAction" class="px-4 py-2 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-lg hover:shadow-lg transition">
              تایید ارسال سفارشات
            </button>
          </div>
        </div>
      </div>

      <!-- جدول سفارشات -->
      <div class="overflow-x-auto rounded-xl border border-gray-800">
        <table class="min-w-full table-auto text-right">
          <thead class="bg-gradient-to-r from-gray-800 to-gray-900">
          <tr>
            <th class="p-3 border-b border-gray-700 text-xs text-gray-400">ردیف</th>
            <th class="p-3 border-b border-gray-700 text-xs text-gray-400 text-center">شماره سفارش</th>
            <th class="p-3 border-b border-gray-700 text-xs text-gray-400 text-center">تاریخ</th>
            <th class="p-3 border-b border-gray-700 text-xs text-gray-400 text-center">کد رهگیری اکسونی</th>
            <th class="p-3 border-b border-gray-700 text-xs text-gray-400 text-center">تعداد اقلام</th>
            <th class="p-3 border-b border-gray-700 text-xs text-gray-400 text-center">مبلغ سفارش</th>
          </tr>
          </thead>
          <tbody class="divide-y divide-gray-800">
          <tr v-for="order in orders" :key="order.id"
              class="hover:bg-gray-800/50 transition cursor-pointer"
              @click="$router.push(`/panel/partnerShopOrderDetail/${order.id}`)">
            <td class="p-3 text-center text-sm text-gray-300">{{ orders.indexOf(order) + 1 }}</td>
            <td class="p-3 text-center text-sm text-gray-300">{{ order.id }}</td>
            <td class="p-3 text-center text-xs text-gray-400">{{ formatDate(order.date_time) }}</td>
            <td class="p-3 text-center text-xs text-blue-400 font-mono">{{ order.exuni_tracking_code }}</td>
            <td class="p-3 text-center text-sm text-gray-300">
              {{ order.total_product_quantity | toMoney }}
              <span class="text-xs text-gray-500 mr-1">عدد</span>
            </td>
            <td class="p-3 text-center text-sm text-gray-300">
              {{ order.total_price | toMoney }}
              <span class="text-xs text-gray-500 mr-1">تومان</span>
            </td>
          </tr>
          </tbody>
        </table>

        <!-- حالت خالی -->
        <div v-if="orders.length === 0 && !isLoading" class="py-12 text-center">
          <div class="mx-auto w-16 h-16 bg-gray-800/70 rounded-full flex items-center justify-center mb-4 border border-gray-700">
            <svg class="w-8 h-8 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"></path>
            </svg>
          </div>
          <p class="text-gray-400">هیچ سفارشی یافت نشد</p>
        </div>
      </div>

      <!-- صفحه‌بندی -->
      <div class="flex flex-col sm:flex-row items-center justify-between mt-6 gap-4">
        <div class="flex items-center gap-2">
          <span class="text-sm text-gray-400 bg-gray-800/70 px-3 py-2 rounded-lg border border-gray-700">
            فاکتور در هر صفحه:
            <input v-model="perPage" @input="fetchOrders(1)" type="text"
                   placeholder="تعداد"
                   class="bg-gray-900 text-gray-300 text-sm rounded border border-gray-700 w-16 mx-1 px-2 py-1 text-center">
          </span>
        </div>

        <div class="flex gap-2">
          <button @click="prevPage" :disabled="currentPage === 1"
                  class="px-4 py-2 text-sm rounded-lg bg-gray-800 text-gray-300 hover:bg-gray-700 border border-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition">
            صفحه قبل
          </button>
          <span class="px-4 py-2 text-sm text-gray-300 bg-gray-800/70 rounded-lg border border-gray-700">صفحه {{ currentPage }}</span>
          <button @click="nextPage" :disabled="(currentPage * perPage) >= totalCount"
                  class="px-4 py-2 text-sm rounded-lg bg-gray-800 text-gray-300 hover:bg-gray-700 border border-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition">
            صفحه بعد
          </button>
        </div>
      </div>

      <!-- Loading State -->
      <div v-if="isLoading" class="mt-6 bg-gray-900/50 rounded-xl p-8 text-center border border-gray-800">
        <div class="inline-block">
          <svg class="animate-spin h-10 w-10 text-purple-500 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <p class="mt-3 text-gray-400">در حال بارگذاری...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateField from "@/components/mcomponents/cleave/DateField";

export default {
  name: 'PartnerShopOrdersList',
  components: {DateField},
  data() {
    return {
      currentPage: 1,
      perPage: 50,
      totalCount: 0,
      showPopup: false,
      orders: [],
      selected: [],
      isLoading: false,
      selectAll: false,
      filters: {
        id: '',
        date: '',
      },
    };
  },
  computed: {
    toId() {
      if (this.orders.length === 0) return ''
      return this.orders[0].id
    },
    fromId() {
      if (this.orders.length === 0) return ''
      return this.orders[this.orders.length - 1].id
    },
  },
  methods: {
    resetFilters() {
      this.filters = {
        id: '',
        date: '',
      }
      this.fetchOrders(1)
    },

    nextPage() {
      if ((this.currentPage * this.perPage) < this.totalCount) {
        this.fetchOrders(this.currentPage + 1)
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.fetchOrders(this.currentPage - 1)
      }
    },

    printConfirmation() {
      this.printPopup = true;
    },
    confirmPrint() {
      this.wait_for_submit = true;
      this.printOrdersToPacking();
    },

    showNotificationMessage(message, type = 'success') {
      this.notificationMessage = message;
      this.notificationType = type;
      this.showNotification = true;
      setTimeout(() => {
        this.showNotification = false;
      }, 5000);
    },

    fetchOrders(page = 1) {
      this.isLoading = true
      const offset = (page - 1) * this.perPage
      const params = {
        limit: this.perPage,
        offset: offset || 0,
      }
      if (this.filters.id) {
        params.id = this.filters.id
      }
      if (this.filters.date) {
        params.date = this.filters.date
      }
      let fetch_url = `partner-stock/shopOrders`

      this.request({
        url: this.endpoint(fetch_url),
        params: params,
        method: "get",
        success: data => {
          this.isLoading = false
          this.orders = data.results
          this.totalCount = data.count
          this.currentPage = page
        }
      })
    },

    formatDate(date) {
      return date ? date.split("T")[0] : "-";
    },

    applyQuickDateFilter() {
      this.filters.date_from = '';
      this.filters.date_to = '';
      this.fetchOrders();
    },

    showConfirmation() {
      this.showPopup = true;
    },

    confirmAction() {
      this.showPopup = false;
      this.printPopup = false;
      this.changeToShipped();
    },
  },

  beforeDestroy() {
    if (this.showPostReport) {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.top = '';
    }
  },

  mounted() {
    this.fetchOrders(1);
  }
};
</script>

<style scoped>
/* تنظیمات Glass Effect */
.glass-effect {
  background: rgba(30, 41, 59, 0.7);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

/* تنظیمات RTL */
[dir="rtl"] .space-x-reverse > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 1;
}

/* اسکرول بار زیبا */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: rgba(30, 41, 59, 0.3);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #4b5563;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #6b7280;
}

/* انیمیشن‌های ظریف */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* انیمیشن اسپینر */
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.animate-spin {
  animation: spin 1s linear infinite;
}
</style>